export enum Instructions {
  // insConsultation = "prepare consultation note from this doctor-patient transcript, in html format: ",
  insSoapNote = "Prepare SOAP note",
  insConsultationDetailed = "ConsultationNoteDetailed",
  // insConsultationPsy = "ConsultationNotePsychiatric",
}
